import { type Network, withDemoMode } from '@/lib/network';

/** Build the canonical share URL for a position card. The page handler
 *  reads `pos` + `oc` from `searchParams` to swap in the per-position
 *  OG metadata. Winner positions supply their winner-detail path. */
export function buildShareUrl(
  marketPubkey: string,
  walletPubkey: string,
  outcomeIndex: number,
  network: Network,
  cacheVersion?: string,
  closed: boolean = false,
  destinationPath: string = `/markets/${marketPubkey}`,
): string {
  if (typeof window === 'undefined') return '';
  const url = new URL(destinationPath, window.location.origin);
  url.searchParams.set('pos', walletPubkey);
  url.searchParams.set('oc', outcomeIndex.toString());
  if (cacheVersion !== undefined) url.searchParams.set('v', cacheVersion);
  if (closed) url.searchParams.set('closed', '1');
  withDemoMode(url, network);
  return url.toString();
}
